import { FiltrosLote as ShipperFiltroLote } from '@sotran/lib-shipper';
import {
  Button as ButtonAntd,
  DatePicker as DatePickerAntd,
  Form as AntForm,
  Row as RowAntd,
  Select as SelectAntd,
} from 'antd';
import styled, { createGlobalStyle } from 'styled-components';

import colors from '../../../../../styles/colors';

export const Styles = createGlobalStyle`

  .radio-btn {
    font-weight: normal;
    font-size: 16px;
  }

  .tabAtivo {
    color: ${colors.$light};
    background: ${colors.$brandcolor_primary_dark_green_5};

    &:hover {
      color: ${colors.$light};
    }
  }
  .tabInativo {
    color: ${colors.$brandcolor_primary_dark_green_5};
    background: ${colors.$light};

    &:hover {
      color: ${colors.$brandcolor_primary_dark_green_5};
    }
  }

  .chart-custom {
    width: 100%;
    height: 70vh;
    text-align: center;
    margin-top: 10px;
  }

  .chart-custom-loading {
    width: 100%;
    height: 70vh;
    text-align: center;
    margin-top: 10px;
    .recharts-wrapper {
      opacity: 0.5;
    }
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn, .ant-tabs-tab:hover, .ant-tabs-tab:active, .ant-tabs-tab-btn:active {
    color: ${colors.$brandcolor_primary_dark_green_5} !important;
    path {
      fill: ${colors.$brandcolor_primary_dark_green_5};
    }
  }

  .ant-tabs-ink-bar.ant-tabs-ink-bar-animated {
    background-color: ${colors.$brandcolor_primary_dark_green_5} !important;
  }

  .radiusLeft {
    border-radius: 4px 0px 0px 4px !important;
  }

  .radiusRight {
    border-radius: 0px 4px 4px 0px !important;
  }

  .rowMensagem {
    bottom: 0;
    position: relative;
    height: 40px;
    margin-left: 12px;
  }

  .filtrosVariacaoFrete {
    width: 100% !important;
  }

  .ant-select-selector {
    border-radius: 2px !important;
  }
`;

export const FormGroup = styled(AntForm.Item)`
  display: flex;
  flex-direction: column;
`;

export const Label = styled.span`
  display: block;
  color: #000000;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 13px;
`;

export const FormButtons = styled(RowAntd)`
  margin-top: 16px;
`;

export const RangerPicker = styled(DatePickerAntd.RangePicker)`
  border-radius: 2px;
`;

export const ConfirmButton = styled(ButtonAntd)`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  color: #fff;
  background: #74aa49;
  border-radius: 2px !important;
  padding: 8px 20px;

  &:hover {
    background: #add290;
    border-color: #add290;
    color: #fff;
  }

  &:focus {
    background: #5c8839;
    border-color: #5c8839;
    color: #fff;
  }
`;

export const CleanButton = styled(ButtonAntd)`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  background: #4190f7;
  border-radius: 2px;
`;

export const IputError = styled.span`
  color: #f71d00;
  font-size: 12px;
  margin-top: 6px;
`;

export const FiltrosLote = styled(ShipperFiltroLote)`
  border-radius: 2px;
`;

export const Select = styled(SelectAntd)`
  border-radius: 2px;
`;
